import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar, LabelList, Tooltip, Legend } from "recharts";
import { numberFormatter } from "../../utils";

const NIARebate = (props: any) => {

    const customTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div className="custom-tooltip">
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Quarter : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {data.quarter}</label></p>
                    {(data.forecastBase > 0 || data.forecastGrowth > 0) && <>
                        <p className="label" style={{ padding: "0", margin: "0" }}>
                            <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Forecasted Base($) : </label>
                            <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                                {numberFormatter(data.forecastBase,2,'$')}</label></p>
                        <p className="label" style={{ padding: "0", margin: "0" }}>
                            <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Forecasted Growth($) : </label>
                            <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                                {numberFormatter(data.forecastGrowth,2,'$')}</label></p>
                    </>
                    }
                    {(data.additionalBase > 0 || data.additionalGrowth > 0) && <><p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Additional Base($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.additionalBase,2,'$')}</label></p>

                        <p className="label" style={{ padding: "0", margin: "0" }}>
                            <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Additional Growth($) : </label>
                            <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                                {numberFormatter(data.additionalGrowth,2,'$')}</label></p>
                    </>
                    }
                </div>
            )
        }
    }

    const updateLegend = (value: any) => {
        if (value == 'forecastBase') {
            return 'Forecasted Base';
        } else if (value == 'additionalBase') {
            return 'Additional Base';
        } else if (value == 'forecastGrowth') {
            return 'Forecasted Growth';
        } else if (value == "additionalGrowth") {
            return 'Additional Growth';
        }
        return '';
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={props.data}
            >
                <XAxis dataKey="quarter" stroke="white" fontSize="1.5vh" />
                <YAxis stroke="white" fontSize="1.5vh" tickFormatter={(value: number) => numberFormatter(value, 0, '$')} />
                <Tooltip contentStyle={{ color: "white", backgroundColor: "rgb(26, 25, 22)" }} cursor={{ strokeDasharray: "3 3", fill:'#212121' }} content={customTooltip} />
                {/* <Legend formatter={(value, entry, index) => updateLegend(value)} /> */}
                <Bar dataKey="forecastBase" stackId="a" fill="#0097a9" barSize={40}>
                    <LabelList dataKey='forecastBase' fill="white" fontWeight={700} fontSize="1.2vh" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="center"></LabelList>
                </Bar>
                <Bar dataKey="additionalBase" stackId="a" fill="#0af680" barSize={40}>
                    <LabelList dataKey='additionalBase' fill="black" fontWeight={700} fontSize="1.2vh" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="center"></LabelList>
                </Bar>
                <Bar dataKey="forecastGrowth" stackId="b" fill="#b08600" barSize={40}>
                    <LabelList dataKey='forecastGrowth' fill="white" fontWeight={700} fontSize="1.2vh" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="center"></LabelList>
                </Bar>

                <Bar dataKey="additionalGrowth" stackId="b" fill="#e3e48d" barSize={40}>
                    <LabelList dataKey='additionalGrowth' fill="black" fontWeight={700} fontSize="1.2vh" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="center"></LabelList>
                </Bar>

            </BarChart>
        </ResponsiveContainer >
    )

}

export default NIARebate;